import EventEmitter from 'eventemitter3';
export var CLICKSTREAM_ANALYTICS_EVENT = 'CLICKSTREAM_ANALYTICS_EVENT';
var clickStreamEventEmitter = new EventEmitter();
export var fireClickstreamEvent = function fireClickstreamEvent(clickStreamEvent) {
  var eventType = clickStreamEvent.getEventType();
  var eventProperties = clickStreamEvent.getEventProperties();
  clickStreamEventEmitter.emit(CLICKSTREAM_ANALYTICS_EVENT, {
    eventType: eventType,
    eventProperties: eventProperties
  });
};
export default clickStreamEventEmitter;